/**
 * Normalizes lead / prelead template upload API payloads.
 * Supports bodies shaped like `{ data: { errors, results, duplicates } }` or a flat object.
 */
export function normalizeTemplateUploadResponse(raw) {
  const inner = raw?.data;
  const payload =
    inner != null && typeof inner === 'object' && !Array.isArray(inner) ? inner : raw ?? {};

  const errorsRaw = payload?.errors ?? [];
  const errors = (Array.isArray(errorsRaw) ? errorsRaw : []).map((e) =>
    typeof e === 'string' ? e : e?.message || e?.error || JSON.stringify(e)
  );

  const resultsRaw = payload?.results ?? [];
  const results = (Array.isArray(resultsRaw) ? resultsRaw : []).map((s) =>
    typeof s === 'object' && s !== null ? s : { name: String(s) }
  );

  const dupRaw = payload?.duplicates ?? [];
  const duplicates = Array.isArray(dupRaw) ? dupRaw : [];

  return { errors, results, duplicates };
}
